import {
  createContext,
  useState,
  FunctionComponent,
  useContext,
  useCallback,
} from 'react'
import { IConsultationDetailsResponseGroup } from '../types'

interface IGroupConsultationContext {
  groupConsultationData: IConsultationDetailsResponseGroup
  setGroupConsultationData: (groupConsultationData) => void
}

const GroupConsultationContext = createContext<IGroupConsultationContext>(null)

export const GroupConsultationProvider: FunctionComponent = ({ children }) => {
  const [groupConsultationState, setGroupConsultationState] = useState(null)

  const setGroupConsultationData = useCallback(
    (groupConsultationData: IConsultationDetailsResponseGroup) => {
      setGroupConsultationState(groupConsultationData)
    },
    [],
  )
  return (
    <GroupConsultationContext.Provider
      value={{
        groupConsultationData: groupConsultationState,
        setGroupConsultationData,
      }}
    >
      {children}
    </GroupConsultationContext.Provider>
  )
}
export const useGroupConsultationContext = (): IGroupConsultationContext => {
  const context = useContext(GroupConsultationContext)
  if (!context) {
    throw new Error(
      'useGroupConsultationContext must be used within a GroupConsultationProvider',
    )
  }
  return context
}
